import { queryOptions } from "@tanstack/react-query";
import { api } from "./client";
import { payload } from "./envelope";
import type { components } from "./schema";

export type PersonaConfig = components["schemas"]["PersonaConfig"];
export type PersonaPreset = components["schemas"]["PersonaPreset"];
export type PersonaConfigRequest = components["schemas"]["PersonaConfigRequest"];

/**
 * O catálogo de estilos que ESTE estabelecimento pode escolher.
 *
 * Não recebe o vertical: quem filtra é o servidor, pelo vertical do
 * estabelecimento autenticado. É de propósito — deixar o front escolher o
 * filtro permitiria uma barbearia vestir a copy revisada de uma clínica.
 *
 * Vertical sem preset cadastrado devolve `[]`, nunca `null`. Na prática não
 * acontece pelos segmentos oferecidos no cadastro: `GET /verticals` só
 * lista vertical que tem persona — mas um estabelecimento antigo pode
 * carregar um vertical que saiu do catálogo, e aí a lista vem vazia.
 */
export function personaPresetsQuery() {
  return queryOptions({
    queryKey: ["persona", "presets"] as const,
    queryFn: () => payload(api.GET("/persona/presets")),
    // Catálogo global e praticamente estático — não vale revalidar.
    staleTime: Number.POSITIVE_INFINITY,
  });
}

/**
 * A persona atual. **Nunca dá 404**: sem configuração salva o backend
 * devolve o default que o bot já está usando, então o formulário sempre abre
 * preenchido com a verdade em vez de campos vazios.
 */
export function personaQuery() {
  return queryOptions({
    queryKey: ["persona", "config"] as const,
    queryFn: () => payload(api.GET("/persona")),
  });
}

/**
 * `PUT /persona`. Só `bot_name` é obrigatório e todo campo ausente preserva
 * o valor atual em vez de zerar — mandamos os quatro justamente porque os
 * quatro estão na tela, então "ausente" nunca é o que o dono quis dizer.
 *
 * `preset_id` tem três comportamentos: ausente mantém, `""` limpa a escolha,
 * uuid escolhe (e precisa ser do mesmo vertical, senão `422`).
 */
export function savePersona(body: PersonaConfigRequest): Promise<PersonaConfig> {
  return payload(api.PUT("/persona", { body }));
}
